import React, { useContext } from "react";
import "./MeetingPageNotes.css";
import { AppContext } from "../../../../appContext";

export const MeetingPageNotes = ()=>{
    const { translate } = useContext(AppContext);
    
    return (
        <div className="meetingPage_notes_wrap">
            <div className="meetingPage_notes">
                <div className="meetingPage_notes_column">
                    <div className="meetingPage_note_h">
                        {translate('highlights_previous_session')}
                    </div>
                    <div className="meetingPage_note_ul">
                        <div className="meetingPage_note_li">
                            {translate('fear_public_speaking')}
                        </div>
                        <div className="meetingPage_note_li">
                            {translate('doubts_attractiveness')}
                        </div>
                        <div className="meetingPage_note_li">
                            {translate('panic_attacks')}
                        </div>
                    </div>
                </div>
                <div className="meetingPage_notes_column">
                    <div className="meetingPage_note_h">
                        {translate('recommendations_upcoming_session')}
                    </div>
                    <div className="meetingPage_note_ul">
                        <div className="meetingPage_note_li">
                            {translate('breathing_exercises')}
                        </div>
                        <div className="meetingPage_note_li">
                            {translate('appointment_psychiatrist')}
                        </div>
                        <div className="meetingPage_note_li">
                            {translate('calming_scheme')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="meetingPage_notes_menu">
                <div className="meetingPage_notes_menu_button meetingPage_notes_menu_button--task">
                    {translate('add_task')}
                </div> 
                <div className="meetingPage_notes_menu_button meetingPage_notes_menu_button--task">
                    {translate('plan_new_session')}
                </div> 
                <div className="meetingPage_notes_menu_button meetingPage_notes_menu_button--task">
                    {translate('open_previous_statistic')}
                </div> 
            </div>
        </div>
    )
}